import { PurchaseForm } from "./ui/form";
import { Footer } from "./footer";

export const Contact = () => {
  return (
    <>
      <div className="main">
        <section className="statement">
          <h1>Purchases & Enquiries</h1>
        </section>
        <section id="work" className="grid">
          <div className="grid-element">
            <p>
              Super Symmetry will be built to order. Construction lead times
              will vary depending on the availability of parts. Although not
              heavy, it includes a custom mounting system that will need to be
              secured with screws to a masonry wall or wooden substrate. The
              piece includes a standard 3-pin UK power plug.
              <br />
              <br />
              Please consider lighting in your choice of hanging and space. The
              surface is mirrored and will act as such if directly lit. The
              piece works best in darker environments and settings.
            </p>
            <PurchaseForm />
          </div>
          <div className="grid-element">
            <div>
              <img src="assets/images/SS-70_2.jpg" alt="SS #1" />
            </div>
            <div className="description">
              <h5 style={{ marginBottom: 0 }}>Super Symmetry</h5>
              <p>Code, digital canvas, screen & frame</p>
              <p>70 x 70cm. (Depth 12cm) </p>
              <p>
                <small>£7,000</small>
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};
